import Notification from '../../molecules/Notification';
import { useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import {
  notificationsHook,
  seenNotificationsHook,
} from '../../../hooks/notificationsHook';
import { useNotificationsStore } from '../../../stores/useNotifications';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Typography } from '../../molecules/Typography';

export interface INotificationCardNotification {
  id: string;
  text: string;
  type: string;
  displayDate: string;
  link: string;
  seenDate?: string;
}

const NotificationCard = () => {
  const navigate = useNavigate();

  const { notifications, page, setPage, hasNotificationPendindg } =
    useNotificationsStore();

  const {
    mutate,
    //isPending,
    data,
  } = notificationsHook({ page, limit: 15 });
  const { mutateSeen } = seenNotificationsHook();

  const onLoadMore = () => {
    const newPage = page + 1;
    setPage(newPage);
    mutate({ page: newPage, limit: 15 });
  };

  useEffect(() => {
    if (notifications.length === 0) {
      mutate({ page, limit: 15 });
    }
  }, [page, notifications.length]);

  useEffect(() => {
    if (hasNotificationPendindg) {
      mutateSeen();
    }
  }, [hasNotificationPendindg]);

  const toContentNavigate = (notification: INotificationCardNotification) => {
    const { link, type } = notification;

    if (!link) return;

    let linkTested = link;

    if (linkTested.includes('conteudo')) {
      linkTested = linkTested
        .replace('assunto', 'modulo')
        .replace('conteudo', 'assunto');
    }

    if (type === 'external') {
      return window.open(linkTested, '_blank');
    }

    navigate(linkTested);
  };

  return (
    <InfiniteScroll
      dataLength={notifications.length}
      next={() => onLoadMore()}
      hasMore={data?.length !== 0}
      loader={
        <Typography className={'text-center'}>
          Carregando notificações...
        </Typography>
      }
      style={{ overflow: 'visible' }}
      scrollableTarget={'side-menu-news'}
      className={'flex flex-col items-end gap-lg'}
    >
      {notifications.map((notification) => (
        <Notification
          key={`notification-${notification.id}`}
          text={notification.text}
          disciplineSlug={notification.type}
          displayDate={notification.displayDate}
          toContentNavigate={() => toContentNavigate(notification)}
        />
      ))}
    </InfiniteScroll>
  );
};

export default NotificationCard;
